import classnames from 'classnames'
import React from 'react'

import { AnonymousLearningItem } from '../../models/AnonymousLearningItem'

import styles from './LearningItemImage.module.scss'

type LearningItemImageProps = {
  learningItem: AnonymousLearningItem
  full?: boolean
} & React.HTMLProps<HTMLImageElement>

export default React.memo(function LearningItemImage({
  learningItem,
  full,
  className,
  ...imageProps
}: LearningItemImageProps) {
  return (
    <img
      className={classnames(styles.LearningItemImage, className)}
      data-learning-item-type={learningItem.type}
      src={(full ? learningItem.imageFileName! : learningItem.thumbnailFileName!) || learningItem.imageFileName! || ''}
      alt={learningItem.title}
      aria-hidden
      {...imageProps}
    />
  )
})
